import { FC } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
  Grid,
} from "@mui/material";

import { useTranslation } from "react-i18next";
import { SCUIButton } from "../../atoms";

interface IProps {
  data?: any;
  order?: any;
  open?: boolean;
  onClose?: any;
  confirmReturn?: any;
  disabledButton?: boolean;
}
export const SCUIYDMPRefundDialog: FC<IProps> = ({
  data,
  order,
  open = false,
  onClose,
  confirmReturn,
  disabledButton,
}) => {
  const { t } = useTranslation();

  const calculateTotalPrice = () => {
    return Object.entries(data).reduce((total, [barcode, quantity]) => {
      const unitPrice =
        order?.orderItems?.find((x: { barcode: any }) => x.barcode === barcode)
          ?.unitPrice || 0;
      return total + unitPrice * Number(quantity); // quantity'yi Number() ile sayıya dönüştürüyoruz
    }, 0);
  };

  const calculateTotalQuantity = () => {
    return Object.values(data).reduce((total:number, quantity) => total + Number(quantity), 0);
  }

  const totalPrice = calculateTotalPrice();
  const totalRefundQuantity: number = calculateTotalQuantity();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{ "& .MuiDialog-paper": { minWidth: "1000px" } }}
    >
      <DialogTitle>
        <h1>{t("YdMp.returnSummary")}</h1>
      </DialogTitle>
      <DialogContent>
        <Paper
          style={{
            width: "100%",
            height: "30rem",
            justifyContent: "center",
            alignItems: "center",
            padding: 1,
          }}
        >
          {Object.entries(data).map(([barcode, quantity], index) => (
            <>
              <Grid
                sx={{ margin: "1.5rem", marginTop: "1rem" }}
                size={{
                  xl: 12,
                  lg: 12,
                  md: 12,
                  xs: 12
                }}>
                <p>
                  <b>{t("YdMp.productName")}&nbsp;:&nbsp;</b>
                  {
                    order?.orderItems?.find(
                      (x: { barcode: any }) => x.barcode === barcode
                    )?.title
                  }
                </p>
                <p style={{ display: "flex", justifyContent: "space-between" }}>
                  <span>
                    <b>{t("YdMp.barcode")}&nbsp;:&nbsp;</b>
                    {barcode}
                  </span>
                  <span>
                    <b>{t("YdMp.unitPrice")}&nbsp;:&nbsp;</b>
                    {
                      order?.orderItems?.find(
                        (x: { barcode: any }) => x.barcode === barcode
                      )?.taxableAmount
                    }
                  </span>
                  <span>
                    <b>{t("YdMp.returnQuantity")}&nbsp;:&nbsp;</b>
                    {quantity}
                  </span>
                </p>
              </Grid>
              {index < Object.entries(data).length - 1 && (
                <hr style={{ margin: "0 1.5rem" }} />
              )}
            </>
          ))}
        </Paper>
      </DialogContent>
      <DialogActions>
        <Grid
          justifyContent="flex-start"
          style={{ width: "75%" }}
          size={{
            xs: 12
          }}>
          <p style={{ textAlign: "left", marginLeft: "1rem" }}>
            <b>{t("YdMp.totalRefundQuantity")}: </b>
            {totalRefundQuantity}
          </p>
          <p style={{ textAlign: "left", marginLeft: "1rem" }}>
            <b>{t("YdMp.totalRefundAmount")}: </b>
            {totalPrice.toFixed(2)}
          </p>
        </Grid>

        <Grid
          justifyContent="flex-end"
          textAlign="end"
          marginTop="1rem"
          size={{
            xs: 12,
            md: 6,
            lg: 1.5,
            xl: 2
          }}>
          <SCUIButton
            text={t("YdMp.confirmReturn")}
            type="secondary"
            sizeType="fixed"
            size={"m"}
            disabled={disabledButton}
            onClick={() => {
              confirmReturn();
            }}
          />
          <SCUIButton
            text={t("YdMp.cancel")}
            type="secondary"
            sizeType="fixed"
            size={"m"}
            style={{ marginLeft: "1rem" }}
            onClick={() => {
              onClose();
            }}
          />
        </Grid>
      </DialogActions>
    </Dialog>
  );
};
